import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import * as authActions from '../../Redux/Auth/AuthActions';
import Navbar from "../../Utils/Navbar/navbar-component";
import Toast from "../../Utils/Toast/toast-component";
import logoImage from '../../Assets/ai-gen-studio.png'


function Privacy() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleRedirect = async (e) => {
        e.preventDefault();
        let path = e.target.value;
        const redirectPath = path || '/home';
        dispatch(authActions.redirectScreen(redirectPath))
        navigate(redirectPath);
    }

    return (
        <div>
            <Toast />
            <div className="min-h-full w-full">
                <Navbar />
                <header>
                    <div className="flex justify-center">
                        <div className="flex shadow-xl rounded-full aspect-[1] align-middle border-none mb-4 mx-4">
                            <img
                                alt="..."
                                src={logoImage}
                                style={{ objectFit: 'cover' }}
                                className={`${true ? 'opacity-100' : 'opacity-0'} flex aspect-[1] rounded-full align-middle border-none  lg:h-54 lg:w-54  h-34 w-32 transition-all duration-150 `}
                                // onLoad={handleImageLoad}
                            />
                        </div>
                    </div>
                </header>
                <main>
                    <div className="flex justify-center mx-auto max-w-7xl sm:px-6 lg:px-8">
                        <div className="flex bg-white dark:bg-black rounded-3xl py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                            <div className="prose dark:prose-invert text-center">
                                <h2>Privacy Policy</h2>
                                <p>Last updated: August 29, 2024</p>
                                <p>
                                    This Privacy Policy describes our policies and procedures on the
                                    collection, use, and disclosure of your information when you use
                                    our Service. You can read the full details{" "}
                                    <a
                                        href="https://www.freeprivacypolicy.com/live/fd852495-8b81-44e3-838f-bd6f7da874a1"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-500 underline"
                                    >
                                        here.
                                    </a>
                                </p>
                                <button
                                    className="button-component mt-4"
                                    onClick={handleRedirect}
                                >
                                    Back to homepage
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default Privacy;